import * as React from "react";
import {useEffect, useState} from "react";
import {Modal} from "../../Modal/Modal";
import {TextInput} from "../../TextInput";
import {Select} from "../../Select";

import {InputFieldState} from "../../InputFieldState";
import {MediaGallery, MediaGalleryImage} from "../../MediaGallery";
import {Translations} from "../../../translations/Translations";
import {DealerNewsEntity} from "../../../services/DealerNews";
import {HtmlInput} from "../../HtmlInput";
import {MetaField, MetaFieldGroup, MetaFieldTypes} from "./MetaFields";
import {TextareaInput} from "../../TextareaInput";
import {DateInputAdmin} from "../../DateInputAdmin";
import {TimeInput} from "../../TimeInput";
import {GalleryInput} from "../../GalleryInput";
import {List} from "../../List";
import {CheckboxMulti} from "../../CheckboxMulti";

type DealerNewsEditModalProps = {
    editFormVisible: boolean,
    onCloseRequest: () => void,
    onSave: (news: DealerNewsEntity) => void,
    trn: Translations,
    news: DealerNewsEntity,
    metaFieldGroups: MetaFieldGroup[],
}

export const DealerNewsEditModal = ({
                                        editFormVisible,
                                        onCloseRequest,
                                        trn,
                                        onSave,
                                        news,
                                        metaFieldGroups
                                    }: DealerNewsEditModalProps) => {
    const [title, setTitle] = useState<InputFieldState>({value: ''});
    const [content, setContent] = useState<InputFieldState>({value: ''});
    const [image, setImage] = useState<MediaGalleryImage>(null);

    const metaFieldStates: any = {};

    metaFieldGroups.map(metaFieldGroup => {
        metaFieldGroup.fields.map(metaField => {
            metaFieldStates[metaField.name] = useState<InputFieldState>({value: ''});
        });
    });

    const save = () => {
        news.title = title.value.toString();
        news.content = content.value.toString();

        if (image) {
            news.picture = image.id;
            news.picture_url = image.url;
        } else {
            news.picture = null;
            news.picture_url = null;
        }

        let newsMetaFields: MetaField[] = [];
        metaFieldGroups.map(metaFieldGroup => {
            metaFieldGroup.fields.map(metaField => {
                newsMetaFields.push({name: metaField.name, value: metaFieldStates[metaField.name][0].value})
            });
        });
        news.meta_fields = JSON.stringify(newsMetaFields);

        onSave(news);
    };

    useEffect(() => {
        if (news) {
            setTitle({value: news.title});
            setContent({value: news.content});
            setImage({id: news.picture, url: news.picture_url});

            if (news.meta_fields) {
                const metaFields = JSON.parse(news.meta_fields);

                metaFields.map((metaField: MetaField) => {
                    metaFieldStates[metaField.name][1]({value: metaField.value});
                });
            }
        }
    }, [news]);

    return <Modal className={"modal-alert dealer-news"} visible={editFormVisible}
                  onCloseRequest={() => onCloseRequest()}
                  title={trn.createEditEntry}>

        <TextInput state={title} label={trn.title} onChange={value => setTitle({value: value})}/>
        <HtmlInput label={trn.content} state={content} onChange={(value) => setContent({value: value})}/>

        {metaFieldGroups.map(metaFieldGroup => {

            return <div style={{
                backgroundColor: '#f5f5f5',
                padding: '15px',
                margin: '20px 0',
                borderRadius: '3px',
            }}>
                <h3 style={{
                    padding: 0,
                    margin: 0,
                }}>{metaFieldGroup.name}</h3>
                {metaFieldGroup.fields.map(metaField => {

                    if (metaField.type == MetaFieldTypes.titleImage) {
                        return <div className={"meta-field-" + metaField.name}>
                            <MediaGallery buttonText={trn.selectImage} label={metaField.label} image={image}
                                          onChange={(image: MediaGalleryImage) => setImage(image)}/>
                        </div>
                    }

                    if (metaField.type == MetaFieldTypes.textarea) {
                        return <div className={"meta-field-" + metaField.name}>
                            <TextareaInput state={metaFieldStates[metaField.name][0]} label={metaField.label}
                                           onChange={value => metaFieldStates[metaField.name][1]({value: value})}/>
                        </div>
                    }

                    if (metaField.type == MetaFieldTypes.input) {
                        return <div className={"meta-field-" + metaField.name}>
                            <TextInput state={metaFieldStates[metaField.name][0]} label={metaField.label}
                                       onChange={value => metaFieldStates[metaField.name][1]({value: value})}/>
                        </div>
                    }

                    if (metaField.type == MetaFieldTypes.number) {
                        return <div className={"meta-field-" + metaField.name}>
                            <TextInput unit={metaField.unit} type={"number"} state={metaFieldStates[metaField.name][0]}
                                       label={metaField.label}
                                       onChange={value => metaFieldStates[metaField.name][1]({value: value})}/>
                        </div>
                    }

                    if (metaField.type == MetaFieldTypes.date) {
                        return <div className={"meta-field-" + metaField.name}>
                            <DateInputAdmin state={metaFieldStates[metaField.name][0]} label={metaField.label}
                                            onChange={value => metaFieldStates[metaField.name][1]({value: value})}/>
                        </div>
                    }

                    if (metaField.type == MetaFieldTypes.time) {
                        return <div className={"meta-field-" + metaField.name}>
                            <TimeInput state={metaFieldStates[metaField.name][0]} label={metaField.label}
                                       onChange={value => metaFieldStates[metaField.name][1]({value: value})}/>
                        </div>
                    }

                    if (metaField.type == MetaFieldTypes.gallery) {
                        return <div className={"meta-field-" + metaField.name}>
                            <GalleryInput maxImages={20} trn={trn} state={metaFieldStates[metaField.name][0]}
                                          label={metaField.label}
                                          onChange={value => metaFieldStates[metaField.name][1]({value: value})}/>
                        </div>
                    }

                    if (metaField.type == MetaFieldTypes.select) {
                        return <div className={"meta-field-" + metaField.name}>
                            <Select state={metaFieldStates[metaField.name][0]} label={metaField.label}
                                    onChange={(value) => metaFieldStates[metaField.name][1]({value: value})}
                                    options={metaField.options}
                            />
                        </div>
                    }

                    if (metaField.type == MetaFieldTypes.list) {
                        return <div className={"meta-field-" + metaField.name}>
                            <List state={metaFieldStates[metaField.name][0]} label={metaField.label}
                                  onChange={(value) => metaFieldStates[metaField.name][1]({value: value})}
                            />
                        </div>
                    }

                    if (metaField.type == MetaFieldTypes.checkboxMulti) {
                        return <div className={"meta-field-" + metaField.name}>
                            <CheckboxMulti label={metaField.label} options={metaField.options}
                                           state={metaFieldStates[metaField.name][0]}
                                           onChange={(value) => metaFieldStates[metaField.name][1]({value: value})}
                            />
                        </div>
                    }
                })}
            </div>

        })
        }

        <a style={{margin: '10px 0'}} className={"button"} onClick={() => save()}>{trn.save}</a>
    </Modal>

}